module.exports = __webpack_public_path__ + "assets/img/6_456.53013314.jpg";